import { DailyBoardEntry, DailyBoardPayload } from '../generated/server';

/** Ranked runs; non-clearers are listed unranked and carry attempts instead. */
export function bossCleared(board: DailyBoardPayload | null): DailyBoardEntry[] {
  return (board?.entries ?? []).filter((e) => e.cleared);
}

export function bossAttempted(board: DailyBoardPayload | null): DailyBoardEntry[] {
  return (board?.entries ?? []).filter((e) => !e.cleared);
}

export function isSelfEntry(entry: DailyBoardEntry, me: string | undefined): boolean {
  return !!me && entry.address.toLowerCase() === me.toLowerCase();
}

export function rankClass(rank: number | null): string {
  if (rank === 1) return 'rank-gold';
  if (rank === 2) return 'rank-silver';
  if (rank === 3) return 'rank-bronze';
  return '';
}
